import React, { useEffect, useState, useCallback } from 'react';
import HeaderVolver from "../HeaderVolver/HeaderVolver";
import { useNavigate } from "react-router-dom";
import useStore from "../../useStore";
import style from "./HistorialPedidos.module.css";
import { obtenerHistorialPedidos, compartirPedido, obtenerPerfil, sendMessage } from "../../repositorios/apiServer";
import grupo46 from "../../assests/imagenes/Grupo 46.png";
import { IoMdCloseCircle } from "react-icons/io";

function Popup({ show, close, productosSeleccionados }) {
  const [formData, setFormData] = useState({
    info: "",
  });
  const navigate = useNavigate();

  let error = [];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const jsonPedido = {
      contacto: formData.info,
      lineasPedido: productosSeleccionados.map(producto => ({
        producto: producto._id || producto.id,
        cantidad: producto.cantidad || 1
      })),
      fecha: new Date().toISOString()
    };

    if (verify()) {
      try {
        const res = await sendMessage(jsonPedido);
        if (res.id) {
          alert("Se ha enviado tu pedido al correo correctamente");
          close();
        }
      } catch (error) {
        console.error("Error al enviar el correo:", error);
        alert("No se pudo enviar el correo. Inténtalo de nuevo.");
      }
    } else {
      alert(error.join("\n"));
    }
  };

  function isEmail() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(formData.info);
  }

  function verify() {
    error = [];
    if (formData.info === "") {
      error.push("El campo no puede estar vacío");
    }

    if (!isEmail()) {
      error.push("El correo no es válido");
    }
    return error.length === 0;
  }

  if (!show) return null;

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginBottom: '20px'
  };

  const titleStyle = {
    margin: 0,
    flex: 1
  };

  const closeButtonStyle = {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontSize: '1.5rem',
    color: '#666',
    padding: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  return (
    <div className={style.modal_backdrop}>
      <div className={style.modal_content}>
        <div style={headerStyle}>
          <h3 style={titleStyle}>¡Déjanos tu correo y no olvides tus platos favoritos!</h3>
          <button 
            style={closeButtonStyle} 
            onClick={close}
          >
            <IoMdCloseCircle />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className={style.form_correo}>
          <input
            type="text"
            className={style.input_correo}
            name="info"
            placeholder="Correo"
            value={formData.info}
            onChange={handleChange}
          />
          <button type="submit" className={style.boton_enviar_correo}>
            Enviar
          </button>
        </form>
        
        <p className={style.texto_popup}>
          Te enviaremos un correo con los platos que seleccionaste para que siempre los tengas presentes cuando vuelvas a visitarnos.
        </p>
      </div>
    </div>
  );
}

export default function HistorialPedidos() {
  const navigate = useNavigate();
  const userToken = useStore((state) => state.userToken);
  const [userData, setUserData] = useState(null);
  const [pedidos, setPedidos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  const [compartiendo, setCompartiendo] = useState(false);
  const [compartidoId, setCompartidoId] = useState(null);
  const [opcionesVisibles, setOpcionesVisibles] = useState(false);
  const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);
  const [isMounted, setIsMounted] = useState(true);

  const [showEmailPopup, setShowEmailPopup] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  useEffect(() => {
    if (!userToken) {
      navigate("/login");
      return;
    }

    const cargarPerfil = async () => {
      if (userToken && !userData) {
        try {
          const perfilData = await obtenerPerfil();
          
          if (!isMounted) return;
          
          if (perfilData && perfilData.user) {
            setUserData(perfilData.user);
          } else {
            navigate("/login");
          }
        } catch (error) {
          console.error("Error al cargar perfil:", error);
          if (isMounted) navigate("/login");
        }
      }
    };

    cargarPerfil();
  }, [userToken, userData, navigate, isMounted]);

  const cargarHistorialPedidos = useCallback(async () => {
    if (!userToken || !userData) return;
    
    try {
      setCargando(true);
      
      const userId = userData.id || userData._id;
      
      const historialData = await obtenerHistorialPedidos(userId);
      
      if (!isMounted) return;
      
      if (historialData && Array.isArray(historialData)) {
        setPedidos(historialData);
      } else {
        setPedidos([]);
      }
    } catch (error) {
      console.error("Error al cargar el historial de pedidos:", error);
      if (isMounted) {
        setError("No se pudo cargar el historial de pedidos. Inténtalo de nuevo más tarde.");
      }
    } finally {
      if (isMounted) {
        setCargando(false);
      }
    }
  }, [userToken, userData, isMounted]);

  useEffect(() => {
    cargarHistorialPedidos();
  }, [cargarHistorialPedidos]);

  const formatearFecha = (fechaString) => {
    if (!fechaString) return "Fecha no disponible";
    
    if (/^\d{2}\/\d{2}\/\d{2}$/.test(fechaString)) {
      return fechaString;
    }
    
    try {
      const fecha = new Date(fechaString);
      const dia = String(fecha.getDate()).padStart(2, '0');
      const mes = String(fecha.getMonth() + 1).padStart(2, '0');
      const año = String(fecha.getFullYear()).slice(-2);
      return `${dia}/${mes}/${año}`;
    } catch (error) {
      return fechaString;
    }
  };
  
  const calcularTotal = (productos) => {
    if (!productos || !productos.length) return 0;
    
    return productos.reduce((total, producto) => {
      const precio = parseFloat(producto.precio) || 0;
      const cantidad = producto.cantidad || 1;
      return total + (precio * cantidad);
    }, 0).toFixed(2);
  };

  const mostrarOpciones = useCallback((pedido) => {
    setPedidoSeleccionado(pedido);
    setOpcionesVisibles(true);
  }, []);

  const cerrarOpciones = useCallback(() => {
    setOpcionesVisibles(false);
  }, []);

  const cerrarEmailPopup = useCallback(() => {
    setShowEmailPopup(false);
    setPedidoSeleccionado(null);
  }, []);

  const handleCompartirPedido = useCallback(async (pedido) => {
    if (!userToken || !userData || !isMounted) {
      navigate("/login");
      return;
    }

    try {
      setCompartiendo(true);
      setCompartidoId(pedido._id);

      const productosVerificados = pedido.Productos.map(p => {
        return {
          _id: p._id || p.id || "",
          nombre: p.nombre || (p.esVino ? "Vino sin nombre" : "Producto sin nombre"),
          precio: parseFloat(p.precio) || 0,
          cantidad: parseInt(p.cantidad) || 1,
          esVino: p.esVino === true
        };
      });
      
      const datosCompartir = {
        pedidoId: pedido._id,
        usuarioId: userToken,
        nombreUsuario: userData?.nombre || "Usuario",
        productos: productosVerificados,
        fecha: new Date().toISOString()
      };
      
      const recomendacionCreada = await compartirPedido(datosCompartir);
      
      if (!isMounted) return;
      
      if (!recomendacionCreada || !recomendacionCreada._id) {
        throw new Error("No se pudo crear la recomendación");
      }
      
      const baseUrl = window.location.origin;
      const recomendacionId = recomendacionCreada._id;
      const enlaceCompartir = `${baseUrl}/recomendaciones/compartido/${recomendacionId}`;

      const nombreProductos = pedido.Productos
        .filter(p => p.nombre)
        .map(p => p.nombre)
        .join(', ');

      const mensajeCompartir = `¡Mira mi pedido en Romana! Te recomiendo: ${nombreProductos} 👉 ${enlaceCompartir}`;
      
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(mensajeCompartir)}`;
      
      try {
        await navigator.clipboard.writeText(enlaceCompartir);
      } catch (clipboardError) {
        console.error("Error al copiar al portapapeles:", clipboardError);
      }
      
      window.open(whatsappUrl, '_blank');
      
    } catch (error) {
      console.error("Error detallado al compartir el pedido:", error);
      if (isMounted) {
        alert("Ha ocurrido un error al compartir el pedido. Inténtalo de nuevo.");
      }
    } finally {
      if (isMounted) {
        setCompartiendo(false);
        setCompartidoId(null);
        cerrarOpciones();
      }
    }
  }, [userToken, userData, navigate, cerrarOpciones, isMounted]);

  const compartirPorGmail = useCallback(() => {
    setShowEmailPopup(true);
    setOpcionesVisibles(false); // Solo ocultamos, no reseteamos pedidoSeleccionado
  }, []);

  const compartirPorFacebook = useCallback(() => {
    alert("Funcionalidad de Facebook en desarrollo. Por ahora, solo está disponible WhatsApp.");
    cerrarOpciones();
  }, [cerrarOpciones]);

  const repetirPedido = useCallback((pedido) => {
    const productosCarrito = pedido.Productos.map(p => {
      return {
        _id: p._id,
        id: p._id,
        nombre: p.nombre || (p.esVino ? "Vino sin nombre" : "Producto sin nombre"),
        precio: p.precio || 0,
        cantidad: p.cantidad || 1,
        esVino: p.esVino === true
      };
    });
    useStore.getState().setCarritoProductos(productosCarrito);
    navigate("/carta");
  }, [navigate]);

  return (
    <div className={style.historial_container}>
      <HeaderVolver 
        tituloPrincipal="Mi historial" 
        tituloDestacado="DE PEDIDOS"
      />

      <div className={style.volver_container}>
       <button 
          className={style.boton_volver} 
          onClick={() => navigate("/carta")}
        >
          Volver
        </button>
      </div>
      
      <div className={style.historial_content}>
        {cargando ? (
          <div className={style.loading_message}>Cargando historial de pedidos...</div>
        ) : error ? (
          <div className={style.error_message}>{error}</div>
        ) : pedidos.length > 0 ? (
          <div className={style.pedidos_lista}>
            {pedidos.map((pedido) => (
              <div key={pedido._id} className={style.pedido_card}>
                <div className={style.pedido_header}>
                  <img src={grupo46} alt="" className={style.pedido_icono} />
                  <div className={style.pedido_fecha}>
                    Pedido con fecha: {formatearFecha(pedido.fechaCreacion)}
                  </div>
                </div>
                
                <div className={style.productos_lista}>
                  {pedido.Productos && pedido.Productos.map((producto, index) => (
                    <div key={index} className={style.producto_item}>
                      <div className={style.producto_nombre}>
                        {producto.nombre || (producto.esVino ? "Vino sin nombre" : "Producto sin nombre")}
                      </div>
                      <div className={style.producto_linea}></div>
                      <div className={style.producto_cantidad}>
                        X{producto.cantidad}
                      </div>
                    </div>
                  ))}
                </div>
                
                <div className={style.pedido_footer}>
                  <div className={style.pedido_total}>
                  </div>
                  <div className={style.botones_container}>
                    <button 
                      className={style.boton_compartir}
                      onClick={() => mostrarOpciones(pedido)}
                      disabled={compartiendo && compartidoId === pedido._id}
                    >
                      {compartiendo && compartidoId === pedido._id ? "Compartiendo..." : "Compartir"}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className={style.empty_history}>
            <p>No tienes pedidos realizados aún.</p>
            <button className={style.boton_realizar_pedido} onClick={() => navigate("/carta")}>
              Realizar un pedido
            </button>
          </div>
        )}
        
        {opcionesVisibles && pedidoSeleccionado && (
          <div className={style.modal_backdrop} onClick={cerrarOpciones}>
            <div className={style.modal_content} onClick={(e) => e.stopPropagation()}>
              <h3 className={style.modal_titulo}>Compartir pedido</h3>
              <div className={style.opciones_container}>
                <button 
                  className={style.opcion_modal} 
                  onClick={() => handleCompartirPedido(pedidoSeleccionado)}
                >
                  <span className={style.icono_opcion}>📱</span>
                  WhatsApp
                </button>
                <button 
                  className={style.opcion_modal} 
                  onClick={compartirPorGmail}
                >
                  <span className={style.icono_opcion}>✉️</span>
                  Gmail
                </button>
                <button 
                  className={style.opcion_modal} 
                  onClick={compartirPorFacebook}
                >
                  <span className={style.icono_opcion}>👍</span>
                  Facebook
                </button>
              </div>
              <button className={style.boton_cerrar} onClick={cerrarOpciones}>
                Cancelar
              </button>
            </div>
          </div>
        )}
        
        {/* Popup para enviar correo */}
        {showEmailPopup && pedidoSeleccionado && (
          <Popup 
            show={showEmailPopup} 
            close={cerrarEmailPopup} 
            productosSeleccionados={pedidoSeleccionado.Productos} 
          />
        )}
      </div>
    </div>
  );
}